<template>
  <v-card>
    <v-card-title>Data Guru </v-card-title>
    <v-card-text>
      <div align="right">
        <v-btn
          dark
          color="green"
          @click="
            req = {};
            modal.import = true;
          "
          v-if="$root.app.isAdmin"
          class="mr-2"
        >
          <v-icon>mdi-file</v-icon>
          Import Excel
        </v-btn>
        <v-btn
          dark
          color="blue"
          @click="
            req = {};
            modal.create = true;
          "
          v-if="$root.app.isAdmin"
        >
          <v-icon>mdi-plus</v-icon>
          Tambah
        </v-btn>
      </div>
      <form
        @submit.prevent="
          () => {
            options.page = filter.page = 1;
            get();
          }
        "
      >
        <v-text-field
          label="Search"
          v-model="filter.search"
          @change="
            () => {
              options.page = filter.page = 1;
              get();
            }
          "
          append-icon="mdi-magnify"
        ></v-text-field>
      </form>
      <v-data-table
        disable-sort
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 50, 100],
        }"
        :headers="[
          {
            text: 'NIP',
            value: 'nip',
          },
          {
            text: 'Username',
            value: 'username',
          },
          {
            text: 'Nama',
            value: 'nama',
          },
          {
            text: 'Jenis PTK',
            value: 'jenis_ptk',
          },
          {
            text: 'Level',
            value: 'level',
          },
          {
            text: 'Opsi',
            value: 'actions',
          },
        ]"
        :items="datas"
        :loading="is.loading"
        loading-text="Loading... Please wait"
        :server-items-length="recordsTotal"
        :options.sync="options"
      >
        <template slot="item.level" slot-scope="{ item }">
          {{ item.level.toUpperCase() }}
        </template>

        <template slot="item.actions" slot-scope="{ item }">
          <v-btn
            icon
            color="blue"
            @click="
              req = item;
              req.password = '';
              modal.edit = true;
            "
          >
            <v-icon>mdi-pen</v-icon>
          </v-btn>
          <v-btn
            icon
            color="red"
            @click="
              req = item;
              modal.delete = true;
            "
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="modal.create">
      <v-form ref="create" @submit.prevent="store">
        <v-card width="500">
          <v-card-title>Tambah Guru</v-card-title>
          <v-card-text>
            <v-alert
              dense
              v-show="is.submit"
              text
              icon="mdi-clock-fast"
              border="left"
              color="blue"
              >Menunggu...</v-alert
            >
            <v-text-field
              v-model="req.nip"
              placeholder="Masukkan NIP"
              label="NIP"
              :rules="[(v) => !!v || 'nip harus diisi']"
            ></v-text-field>
            <v-text-field
              v-model="req.nama"
              placeholder="Masukkan Nama"
              label="Nama"
              :rules="[(v) => !!v || 'nama harus diisi']"
            ></v-text-field>
            <v-text-field
              v-model="req.jenis_ptk"
              placeholder="Masukkan Jenis PTK"
              label="Jenis PTK"
              :rules="[(v) => !!v || 'jenis PTK harus diisi']"
            ></v-text-field>
            <v-text-field
              v-model="req.username"
              placeholder="Masukkan Username"
              label="Username"
              :rules="[(v) => !!v || 'username harus diisi']"
            ></v-text-field>
            <v-text-field
              type="password"
              v-model="req.password"
              placeholder="Masukkan Password"
              label="Password"
              :rules="[
                (v) => !!v || 'password harus diisi',
                (v) =>
                  !(v ? v.length < 8 : true) || 'password minimal 8 karakter',
              ]"
              counter="20"
              maxlength="20"
            ></v-text-field>
            <v-select
              label="Level"
              v-model="req.level"
              :rules="[(v) => !!v || 'level harus dipilih']"
              :items="[
                {
                  value: 'admin',
                  text: 'Admin',
                },
                {
                  value: 'user',
                  text: 'User',
                },
                {
                  value: 'bk',
                  text: 'BK',
                },
              ]"
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Simpan</v-btn>
            <v-btn type="button" text color="red" @click="modal.create = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="modal.edit">
      <v-form ref="edit" @submit.prevent="update">
        <v-card width="500">
          <v-card-title>Edit Guru</v-card-title>
          <v-card-text>
            <v-tabs v-model="data.tab">
              <v-tab>Data</v-tab>
              <v-tab>Autentikasi</v-tab>
            </v-tabs>
            <div class="mb-4"></div>
            <v-alert
              dense
              v-show="is.submit"
              text
              icon="mdi-clock-fast"
              border="left"
              color="blue"
              >Menunggu...</v-alert
            >
            <v-tabs-items v-model="data.tab">
              <v-tab-item>
                <v-text-field
                  v-model="req.nip"
                  placeholder="Masukkan NIP"
                  label="NIP"
                  :rules="[(v) => !!v || 'nip harus diisi']"
                ></v-text-field>
                <v-text-field
                  v-model="req.nama"
                  placeholder="Masukkan Nama"
                  label="Nama"
                  :rules="[(v) => !!v || 'nama harus diisi']"
                ></v-text-field>
                <v-text-field
                  v-model="req.jenis_ptk"
                  placeholder="Masukkan Jenis PTK"
                  label="Jenis PTK"
                  :rules="[(v) => !!v || 'jenis PTK harus diisi']"
                ></v-text-field>
                <v-select
                  label="Level"
                  v-model="req.level"
                  :rules="[(v) => !!v || 'level harus dipilih']"
                  :items="[
                    {
                      value: 'admin',
                      text: 'Admin',
                    },
                    {
                      value: 'user',
                      text: 'User',
                    },
                    {
                      value: 'bk',
                      text: 'BK',
                    },
                  ]"
                ></v-select>
              </v-tab-item>
              <v-tab-item>
                <v-text-field
                  v-model="req.username"
                  placeholder="Masukkan Username"
                  label="Username"
                  :rules="[(v) => !!v || 'username harus diisi']"
                ></v-text-field>
                <v-text-field
                  type="password"
                  v-model="req.password"
                  placeholder="Masukkan Password"
                  label="Password"
                  :rules="[
                    (v) => !!v || 'password harus diisi',
                    (v) =>
                      !(v ? v.length < 8 : true) ||
                      'password minimal 8 karakter',
                  ]"
                  counter="20"
                  maxlength="20"
                ></v-text-field>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Simpan</v-btn>
            <v-btn type="button" text color="red" @click="modal.edit = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="modal.delete">
      <v-card width="450">
        <v-form @submit.prevent="destroy">
          <v-card-title>Hapus Guru</v-card-title>
          <v-card-text>Anda yakin menghapus {{ req.nama }}?</v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Hapus</v-btn>
            <v-btn type="button" text color="red" @click="modal.delete = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modal.import">
      <v-card width="500">
        <v-form @submit.prevent="importAction">
          <v-card-title>Import Guru</v-card-title>
          <v-card-text>
            <p>
              Unduh contoh format import
              <a :href="contohImport" target="_blank">disini</a>
            </p>
            <v-file-input
              @change="handleImport"
              label="File"
              hint="Pilih File"
              persistent-hint
              show-size
              accept="application/*"
            ></v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" color="blue" text>Simpan</v-btn>
            <v-btn type="button" color="red" text @click="modal.import = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      datas: [],
      modal: {
        create: false,
        edit: false,
        delete: false,
        import: false,
      },
      req: {},
      is: {
        loading: true,
        submit: false,
      },
      filter: {
        limit: 10,
        search: "",
        page: 1,
      },
      options: {},
      recordsTotal: 0,
      data: {
        tab: null,
      },
      contohImport: "",
      req_import: {},
    };
  },
  created() {
    this.get();
  },
  watch: {
    options(val) {
      this.filter.limit = val.itemsPerPage;
      this.filter.page = val.page;
      this.get();
    },
  },
  methods: {
    get() {
      this.req = {};
      this.is.loading = true;
      this.$root.app.http.get("/api/guru", this.filter).then((res) => {
        this.contohImport = res.contohImport;
        this.datas = res.data;
        this.recordsTotal = res.recordsTotal;
        this.is.loading = false;
      });
    },
    store() {
      this.is.submit = true;
      if (this.$refs.create.validate()) {
        this.$root.app.http.post("/api/guru", this.req).then((res) => {
          this.is.submit = false;
          if (res.error) {
            this.$root.app.notif(res.message[0], true);
          } else {
            this.get();
            this.modal.create = false;
            this.$root.app.notif(res.message);
          }
        });
      }
    },
    update() {
      this.is.submit = true;
      if (this.$refs.edit.validate()) {
        if (this.data.tab == 1) {
          this.$root.app.http
            .put("/api/guru/" + this.req.id + "/autentikasi", {
              username: this.req.username,
              password: this.req.password,
            })
            .then((res) => {
              this.is.submit = false;
              if (res.error) {
                this.$root.app.notif(res.message[0], true);
              } else {
                this.get();
                this.modal.edit = false;
                this.$root.app.notif(res.message);
              }
            });
        } else {
          this.$root.app.http
            .put("/api/guru/" + this.req.id, this.req)
            .then((res) => {
              this.is.submit = false;
              if (res.error) {
                this.$root.app.notif(res.message[0], true);
              } else {
                this.get();
                this.modal.edit = false;
                this.$root.app.notif(res.message);
              }
            });
        }
      }
    },
    destroy() {
      this.$root.app.http.del("/api/guru/" + this.req.id).then((res) => {
        if (res.error) {
          this.$root.app.notif(res.message[0], true);
        } else {
          this.get();
          this.modal.delete = false;
          this.$root.app.notif(res.message);
        }
      });
    },
    importAction() {
      this.$root.app.http
        .post("/api/guru/import", this.req_import)
        .then((res) => {
          if (res.error) {
            this.$root.app.notif(res.message[0], true);
          } else {
            this.get();
            this.modal.import = false;
            this.$root.app.notif(res.message);
          }
        });
    },
    handleImport(val) {
      this.$root.app.toBase64(val, (result) => {
        this.req_import.file = result;
      });
    },
  },
};
</script>
